import React, { useState } from 'react';
import { css } from '@emotion/react';

import t from 'react-translate';
import NvSwitch from 'shared/components/inputs/nv-switch';
import ClickableContainer from 'components/clickable-container';
import NvModal, { ModalType } from 'shared/components/nv-modal';
import DailyReportConfigurationModal from './daily-report-configuration-modal';

type DailyEmailSwitchProps = {
  isDailyReportEnabled: boolean
  toggleDailyReport: () => void
  onUpdateReportConfiguration: (data: any) => Promise<boolean>
  initialConfig?: {
    scheduledAt: string;
    recipientUserIds: number[];
  }
};

const DailyEmailSwitch: React.FC<DailyEmailSwitchProps> = ({
  isDailyReportEnabled,
  toggleDailyReport,
  onUpdateReportConfiguration,
  initialConfig,
}) => {
  const [showConfigureModal, setShowConfigureModal] = useState(false);

  return (
    <div className='d-flex justify-content-between gray-1 px-4 py-1 w-100'>
      <div className='d-flex mr-4'>
        <span>{t.CUSTOM_DOWNLOADS.DAILY_REPORT.OPTION_LABEL()}</span>
        <ClickableContainer
          onClick={() => setShowConfigureModal(true)}
          className='text-primary ml-1'
        >
          {t.CUSTOM_DOWNLOADS.SETTINGS()}
        </ClickableContainer>
      </div>
      <NvSwitch
        checked={isDailyReportEnabled}
        onChange={toggleDailyReport}
        enabledLabel={t.SHARED.ON().toUpperCase()}
        disabledLabel={t.SHARED.OFF().toUpperCase()}
      />
      {showConfigureModal && (
        <NvModal
          show={showConfigureModal}
          height='auto'
          type={ModalType.FIXED}
          onClose={() => setShowConfigureModal(false)}
          header={t.CUSTOM_DOWNLOADS.DAILY_REPORT.MODAL.TITLE()}
          width={800}
          modalStyles={css`.bs4-modal-body {
            overflow-y: visible;
          }`}
          body={(
            <DailyReportConfigurationModal
              showModal={setShowConfigureModal}
              onSubmit={onUpdateReportConfiguration}
              initialConfig={initialConfig}
            />
          )}
        />
      )}
    </div>
  );
};


export default DailyEmailSwitch;
